import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/list/table${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/list/table`;

export const URL = (tableQuery: TableQuery): RouteDefinition =>
	`${baseRoute}/list/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}`;
